import { useEffect, useState } from "react";

export default function OutsideClick(ref: any, headerRef: any) {
  const [isClicked, setIsClicked] = useState(false);
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    function handleClickOutside(event: MouseEvent) {
      if (
        ref.current &&
        !ref.current.contains(event.target) &&
        !headerRef.current?.contains(event.target)
      ) {
        setIsClicked(true);
        event.stopPropagation();
      } else {
        setIsClicked(false);
      }
    }

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [ref]);
  return isClicked;
}
